import React from 'react';

interface MetricCardProps {
  title: string;
  value: string;
  icon: string;
  iconColor: 'green' | 'red' | 'blue' | 'orange' | 'purple' | 'emerald';
  change?: {
    value: number;
    type: 'positive' | 'negative' | 'neutral';
  };
  subtitle?: string;
}

const colorSchemes = {
  green: {
    bg: 'bg-green-100',
    text: 'text-green-600',
    value: 'text-green-600'
  },
  red: {
    bg: 'bg-red-100',
    text: 'text-red-600',
    value: 'text-red-600'
  },
  blue: {
    bg: 'bg-blue-100',
    text: 'text-blue-600',
    value: 'text-blue-600'
  },
  orange: {
    bg: 'bg-orange-100',
    text: 'text-orange-600',
    value: 'text-orange-600'
  },
  purple: {
    bg: 'bg-purple-100',
    text: 'text-purple-600',
    value: 'text-purple-600'
  },
  emerald: {
    bg: 'bg-emerald-100',
    text: 'text-emerald-600',
    value: 'text-emerald-600'
  }
};

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  icon,
  iconColor,
  change,
  subtitle
}) => {
  const colorScheme = colorSchemes[iconColor];

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm text-gray-600">{title}</p>
          <p className={`text-2xl font-bold mt-1 ${colorScheme.value}`}>
            {value}
          </p>
          {subtitle && (
            <p className="text-xs text-gray-500 mt-1">{subtitle}</p>
          )}
          {change && (
            <div className={`flex items-center space-x-1 mt-2 text-sm ${
              change.type === 'positive' ? 'text-green-600' : 
              change.type === 'negative' ? 'text-red-600' : 'text-gray-600'
            }`}>
              <i className={`ri-arrow-${change.type === 'positive' ? 'up' : change.type === 'negative' ? 'down' : 'right'}-line`}></i>
              <span>{change.value > 0 ? '+' : ''}{change.value}%</span>
            </div>
          )}
        </div>
        
        <div className={`w-12 h-12 ${colorScheme.bg} rounded-lg flex items-center justify-center`}>
          <i className={`${icon} ${colorScheme.text} text-xl`}></i>
        </div>
      </div>
    </div>
  );
};